// extracted by mini-css-extract-plugin
export default {"table-tabs":"table-tabs_table-tabs__wST7i"};